import React from 'react';

import ToggleOn from "./toggle-on";
import ToggleOff from "./toggle-off";
import {ToggleSize} from "./toggle-statefull"

type Props = {
    className?      : string,
    value           : boolean,
    disabled?       : boolean,
    onClick?        : callback
    size            : ToggleSize
}

export default function FieldToggle_Component(props:Props) {

    const classes = Classes("gd-toggle", "size-"+props.size, props.className, {
        "checked": props.value,
        "disabled": props.disabled
    });

    const onClick = (e:React.SyntheticEvent) => {
        e.stopPropagation()

        if (props.disabled) return
        if (props.onClick) props.onClick()
    }

    return (
        <div className={classes} onClick={onClick}>
            <div className="toggle-track">
                {props.value && <ToggleOn/>}
                {!props.value && <ToggleOff/>}
            </div>
            <div className="toggle-thumb"/>
        </div>
    );
}

